import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useStrictLocalization } from "@faire/web--source/common/localization/localize";
import { Button } from "@faire/web--source/slate/Button";
import { Typography } from "@faire/web--source/slate/Typography";
import React from "react";
import { useFaireDirectMarketplaceIncentiveBannerTextContent } from "./__internal__/useFaireDirectMarketplaceIncentiveBannerTextContent";
import { useFaireDirectMarketplaceIncentiveBannerViewDetailsHandleClick } from "./__internal__/useFaireDirectMarketplaceIncentiveBannerViewDetailsHandleClick";
export var FaireDirectMarketplaceIncentiveBanner = function() {
    var strictLocalize = useStrictLocalization().strictLocalize;
    var handleClick = useFaireDirectMarketplaceIncentiveBannerViewDetailsHandleClick();
    var header = useFaireDirectMarketplaceIncentiveBannerTextContent();
    return /*#__PURE__*/ _jsxs(Typography, {
        align: "center",
        "data-test-id": "faire-direct-marketplace-incentive-banner",
        children: [
            header,
            " ",
            /*#__PURE__*/ _jsx(Button, {
                variant: "tertiary",
                onClick: handleClick,
                children: strictLocalize({
                    id: "Zxul5c",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "View details"
                        }
                    ]
                })
            })
        ]
    });
};
